var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDjangoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 261418 333333",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117587 0h54579v250154c-27956 5288-48537 7369-70805 7369C34700 257453 0 227673 0 170476c0-55108 36807-90874 93845-90874 8851 0 15594 697 23742 2783V0zm143831 86317v125248c0 43133-3231 63876-12714 81759-8851 17193-20511 28034-44604 40008l-50645-23866c24093-11197 35753-21091 43200-36189 7796-15440 10255-33324 10255-80361V86317h54509v-1zM201409 0h54579v55457h-54579V0zm-81909 127465c-6392-2087-11660-2783-18404-2783-27605 0-43550 16838-43550 46348 0 28731 15243 44595 43200 44595 6040 0 10957-340 18754-1384v-86776z",
    fill: "#2ba977"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDjangoIcon);
export default __webpack_public_path__ + "static/media/django-icon.9b99a8ead08a1cea1ab735ce797a3beb.svg";
export { ForwardRef as ReactComponent };